export { PaintIcon } from "./paint";
